import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDriverScheduleQueryVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
}>;


export type GetDriverScheduleQuery = { __typename?: 'query_root', businesshours: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, driver_id?: number | null, location_id?: number | null, day_of_week?: number | null, day?: number | null, month?: number | null, year?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null, created_by: string, updated_by: string, created_at: string, updated_at: string }> };

export type GetMultipleDriverSchedulesQueryVariables = Types.Exact<{
  driverIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type GetMultipleDriverSchedulesQuery = { __typename?: 'query_root', businesshours: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, driver_id?: number | null, location_id?: number | null, day_of_week?: number | null, day?: number | null, month?: number | null, year?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null, created_by: string, updated_by: string, created_at: string, updated_at: string }> };

export type CreateDriverScheduleMutationVariables = Types.Exact<{
  driverSchedule: Array<Types.Businesshours_Insert_Input> | Types.Businesshours_Insert_Input;
}>;


export type CreateDriverScheduleMutation = { __typename?: 'mutation_root', insert_businesshours?: { __typename?: 'businesshours_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, location_id?: number | null, day_of_week?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null }> } | null };

export type UpdateDriverScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  input: Types.Businesshours_Set_Input;
}>;


export type UpdateDriverScheduleMutation = { __typename?: 'mutation_root', update_businesshours?: { __typename?: 'businesshours_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, location_id?: number | null, day_of_week?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null }> } | null };

export type DeleteDriverScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type DeleteDriverScheduleMutation = { __typename?: 'mutation_root', delete_businesshours?: { __typename?: 'businesshours_mutation_response', affected_rows: number } | null };


export const GetDriverScheduleDocument = gql`
    query GetDriverSchedule($driverId: bigint!) {
  businesshours(
    where: {_or: [{driver_id: {_eq: $driverId}, type: {_eq: "business-hours"}}, {driver_id: {_eq: $driverId}, type: {_eq: "one-off"}}, {driver_id: {_is_null: true}, type: {_eq: "driver-default-hours"}}]}
    order_by: [{day_of_week: asc}, {year: asc}, {month: asc}, {day: asc}, {open_time: asc}]
  ) {
    id
    name
    type
    driver_id
    location_id
    day_of_week
    day
    month
    year
    is_open
    open_time
    closed_time
    created_by
    updated_by
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetDriverScheduleQuery__
 *
 * To run a query within a React component, call `useGetDriverScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverScheduleQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useGetDriverScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetDriverScheduleQuery, GetDriverScheduleQueryVariables> & ({ variables: GetDriverScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>(GetDriverScheduleDocument, options);
      }
export function useGetDriverScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>(GetDriverScheduleDocument, options);
        }
// @ts-ignore
export function useGetDriverScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>;
export function useGetDriverScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverScheduleQuery | undefined, GetDriverScheduleQueryVariables>;
export function useGetDriverScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>(GetDriverScheduleDocument, options);
        }
export type GetDriverScheduleQueryHookResult = ReturnType<typeof useGetDriverScheduleQuery>;
export type GetDriverScheduleLazyQueryHookResult = ReturnType<typeof useGetDriverScheduleLazyQuery>;
export type GetDriverScheduleSuspenseQueryHookResult = ReturnType<typeof useGetDriverScheduleSuspenseQuery>;
export type GetDriverScheduleQueryResult = Apollo.QueryResult<GetDriverScheduleQuery, GetDriverScheduleQueryVariables>;
export const GetMultipleDriverSchedulesDocument = gql`
    query GetMultipleDriverSchedules($driverIds: [bigint!]!) {
  businesshours(
    where: {_or: [{driver_id: {_in: $driverIds}, type: {_eq: "business-hours"}}, {driver_id: {_in: $driverIds}, type: {_eq: "one-off"}}, {driver_id: {_is_null: true}, type: {_eq: "driver-default-hours"}}]}
    order_by: [{driver_id: asc}, {day_of_week: asc}, {year: asc}, {month: asc}, {day: asc}, {open_time: asc}]
  ) {
    id
    name
    type
    driver_id
    location_id
    day_of_week
    day
    month
    year
    is_open
    open_time
    closed_time
    created_by
    updated_by
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetMultipleDriverSchedulesQuery__
 *
 * To run a query within a React component, call `useGetMultipleDriverSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleDriverSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleDriverSchedulesQuery({
 *   variables: {
 *      driverIds: // value for 'driverIds'
 *   },
 * });
 */
export function useGetMultipleDriverSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables> & ({ variables: GetMultipleDriverSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>(GetMultipleDriverSchedulesDocument, options);
      }
export function useGetMultipleDriverSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>(GetMultipleDriverSchedulesDocument, options);
        }
// @ts-ignore
export function useGetMultipleDriverSchedulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>;
export function useGetMultipleDriverSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMultipleDriverSchedulesQuery | undefined, GetMultipleDriverSchedulesQueryVariables>;
export function useGetMultipleDriverSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>(GetMultipleDriverSchedulesDocument, options);
        }
export type GetMultipleDriverSchedulesQueryHookResult = ReturnType<typeof useGetMultipleDriverSchedulesQuery>;
export type GetMultipleDriverSchedulesLazyQueryHookResult = ReturnType<typeof useGetMultipleDriverSchedulesLazyQuery>;
export type GetMultipleDriverSchedulesSuspenseQueryHookResult = ReturnType<typeof useGetMultipleDriverSchedulesSuspenseQuery>;
export type GetMultipleDriverSchedulesQueryResult = Apollo.QueryResult<GetMultipleDriverSchedulesQuery, GetMultipleDriverSchedulesQueryVariables>;
export const CreateDriverScheduleDocument = gql`
    mutation CreateDriverSchedule($driverSchedule: [businesshours_insert_input!]!) {
  insert_businesshours(objects: $driverSchedule) {
    affected_rows
    returning {
      id
      name
      type
      location_id
      day_of_week
      is_open
      open_time
      closed_time
    }
  }
}
    `;
export type CreateDriverScheduleMutationFn = Apollo.MutationFunction<CreateDriverScheduleMutation, CreateDriverScheduleMutationVariables>;

/**
 * __useCreateDriverScheduleMutation__
 *
 * To run a mutation, you first call `useCreateDriverScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverScheduleMutation, { data, loading, error }] = useCreateDriverScheduleMutation({
 *   variables: {
 *      driverSchedule: // value for 'driverSchedule'
 *   },
 * });
 */
export function useCreateDriverScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverScheduleMutation, CreateDriverScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverScheduleMutation, CreateDriverScheduleMutationVariables>(CreateDriverScheduleDocument, options);
      }
export type CreateDriverScheduleMutationHookResult = ReturnType<typeof useCreateDriverScheduleMutation>;
export type CreateDriverScheduleMutationResult = Apollo.MutationResult<CreateDriverScheduleMutation>;
export type CreateDriverScheduleMutationOptions = Apollo.BaseMutationOptions<CreateDriverScheduleMutation, CreateDriverScheduleMutationVariables>;
export const UpdateDriverScheduleDocument = gql`
    mutation UpdateDriverSchedule($id: bigint!, $input: businesshours_set_input!) {
  update_businesshours(where: {id: {_eq: $id}}, _set: $input) {
    affected_rows
    returning {
      id
      name
      type
      location_id
      day_of_week
      is_open
      open_time
      closed_time
    }
  }
}
    `;
export type UpdateDriverScheduleMutationFn = Apollo.MutationFunction<UpdateDriverScheduleMutation, UpdateDriverScheduleMutationVariables>;

/**
 * __useUpdateDriverScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateDriverScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverScheduleMutation, { data, loading, error }] = useUpdateDriverScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDriverScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverScheduleMutation, UpdateDriverScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverScheduleMutation, UpdateDriverScheduleMutationVariables>(UpdateDriverScheduleDocument, options);
      }
export type UpdateDriverScheduleMutationHookResult = ReturnType<typeof useUpdateDriverScheduleMutation>;
export type UpdateDriverScheduleMutationResult = Apollo.MutationResult<UpdateDriverScheduleMutation>;
export type UpdateDriverScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateDriverScheduleMutation, UpdateDriverScheduleMutationVariables>;
export const DeleteDriverScheduleDocument = gql`
    mutation DeleteDriverSchedule($id: bigint!) {
  delete_businesshours(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteDriverScheduleMutationFn = Apollo.MutationFunction<DeleteDriverScheduleMutation, DeleteDriverScheduleMutationVariables>;

/**
 * __useDeleteDriverScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteDriverScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverScheduleMutation, { data, loading, error }] = useDeleteDriverScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDriverScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriverScheduleMutation, DeleteDriverScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriverScheduleMutation, DeleteDriverScheduleMutationVariables>(DeleteDriverScheduleDocument, options);
      }
export type DeleteDriverScheduleMutationHookResult = ReturnType<typeof useDeleteDriverScheduleMutation>;
export type DeleteDriverScheduleMutationResult = Apollo.MutationResult<DeleteDriverScheduleMutation>;
export type DeleteDriverScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteDriverScheduleMutation, DeleteDriverScheduleMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/gql/driverSchedule.gql}
 */
export async function createDriverSchedule(
  variables: CreateDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateDriverScheduleMutation['insert_businesshours']>
export async function createDriverSchedule(
  variables: CreateDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateDriverScheduleMutation>
export async function createDriverSchedule(
  variables: CreateDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateDriverScheduleMutation['insert_businesshours'] | CreateDriverScheduleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateDriverScheduleMutation>(
    CreateDriverScheduleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_businesshours
}

/**
 * @source {@link src/features/drivers/gql/driverSchedule.gql}
 */
export async function deleteDriverSchedule(
  variables: DeleteDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteDriverScheduleMutation['delete_businesshours']>
export async function deleteDriverSchedule(
  variables: DeleteDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteDriverScheduleMutation>
export async function deleteDriverSchedule(
  variables: DeleteDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteDriverScheduleMutation['delete_businesshours'] | DeleteDriverScheduleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteDriverScheduleMutation>(
    DeleteDriverScheduleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_businesshours
}

/**
 * @source {@link src/features/drivers/gql/driverSchedule.gql}
 */
export async function getDriverSchedule(
  variables: GetDriverScheduleQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriverScheduleQuery['businesshours']>
export async function getDriverSchedule(
  variables: GetDriverScheduleQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriverScheduleQuery>
export async function getDriverSchedule(
  variables: GetDriverScheduleQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriverScheduleQuery['businesshours'] | GetDriverScheduleQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriverScheduleQuery>(
    GetDriverScheduleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.businesshours
}

/**
 * @source {@link src/features/drivers/gql/driverSchedule.gql}
 */
export async function getMultipleDriverSchedules(
  variables: GetMultipleDriverSchedulesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMultipleDriverSchedulesQuery['businesshours']>
export async function getMultipleDriverSchedules(
  variables: GetMultipleDriverSchedulesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMultipleDriverSchedulesQuery>
export async function getMultipleDriverSchedules(
  variables: GetMultipleDriverSchedulesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMultipleDriverSchedulesQuery['businesshours'] | GetMultipleDriverSchedulesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMultipleDriverSchedulesQuery>(
    GetMultipleDriverSchedulesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.businesshours
}

/**
 * @source {@link src/features/drivers/gql/driverSchedule.gql}
 */
export async function updateDriverSchedule(
  variables: UpdateDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateDriverScheduleMutation['update_businesshours']>
export async function updateDriverSchedule(
  variables: UpdateDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateDriverScheduleMutation>
export async function updateDriverSchedule(
  variables: UpdateDriverScheduleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateDriverScheduleMutation['update_businesshours'] | UpdateDriverScheduleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateDriverScheduleMutation>(
    UpdateDriverScheduleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_businesshours
}